class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/* DERBYX - recherche exacte : la page de resultats ne montre que les produits dont le titre contient les mots tapes. */
(function () {
  function clean(q) {
    return String(q || '')
      .replace(/title:/gi, ' ')
      .replace(/ AND /g, ' ')
      .replace(/["()*:]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function strict(q) {
    return clean(q)
      .split(' ')
      .filter(function (word) {
        return /[0-9A-Za-zÀ-ɏ]/.test(word);
      })
      .map(function (word) {
        return 'title:' + word;
      })
      .join(' ');
  }

  function isSearchPath(path) {
    var p = String(path || '').split('?')[0].split('#')[0];
    if (p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p.slice(-7) === '/search';
  }

  function searchUrl(path, q, extra) {
    return String(path).split('?')[0] + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last' + (extra || '');
  }

  function currentQuery() {
    return new URLSearchParams(window.location.search).get('q') || '';
  }

  // 1) Formulaires de recherche : on cherche uniquement dans le titre des produits
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute || !isSearchPath(form.getAttribute('action'))) return;
      if (form.querySelector('[aria-selected="true"] a')) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !strict(input.value)) return;
      event.preventDefault();
      window.location.href = searchUrl(form.getAttribute('action'), strict(input.value));
    },
    true
  );

  // 2) Liens du type "Voir tous les resultats"
  document.addEventListener(
    'click',
    function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin || !isSearchPath(url.pathname)) return;
      var q = url.searchParams.get('q') || '';
      if (!strict(q) || /title:/i.test(q)) return;
      // Sur la page de secours (recherche large), on laisse la pagination tranquille
      if (isSearchPath(window.location.pathname) && currentQuery() && !/title:/i.test(currentQuery())) return;
      event.preventDefault();
      window.location.href = searchUrl(url.pathname, strict(q));
    },
    true
  );

  // 3) Page de resultats : affichage propre + secours si rien n'est trouve (faute de frappe)
  function tidy() {
    if (!isSearchPath(window.location.pathname)) return;
    var q = currentQuery();
    if (!/title:/i.test(q)) return;

    if (!document.querySelector('#product-grid li') && clean(q)) {
      window.location.replace(searchUrl(window.location.pathname, clean(q), '&exact=0'));
      return;
    }

    document.querySelectorAll('input[type="search"]').forEach(function (input) {
      if (/title:/i.test(input.value)) input.value = clean(input.value);
    });
    document.title = document.title.replace(/title:/gi, '');

    var main = document.querySelector('main') || document.body;
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode ? node.parentNode.nodeName : '';
      if (parent !== 'SCRIPT' && parent !== 'STYLE' && /title:/i.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/title:/gi, '');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tidy);
  } else {
    tidy();
  }
})();
